/*
 * Xocolatl theme behaviour. No dependencies. Every page works without it (forms post, links navigate);
 * this adds the canvas interactions: option buttons, pincode checks, cake dates, accordions, help tabs.
 */
(function () {
  'use strict';

  var S = window.xoSettings || {};
  var PIN_KEY = 'xo_pin';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = S.moneyFormat || '₹{{amount_no_decimals}}';
    var value = (cents / 100);
    var withDecimals = value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDecimals = Math.round(value).toLocaleString('en-IN');
    var amount = cents % 100 === 0 ? noDecimals : withDecimals;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator') return noDecimals;
      return amount;
    });
  }

  /* ---------- pincode ---------- */
  function getPin() { try { return localStorage.getItem(PIN_KEY) || ''; } catch (e) { return ''; } }
  function setPin(pin) { try { localStorage.setItem(PIN_KEY, pin); } catch (e) { /* private mode */ } renderPinChip(); }
  function cleanPin(v) { return String(v || '').replace(/\D/g, '').slice(0, 6); }
  function validPin(pin) { return /^[1-9]\d{5}$/.test(pin); }
  function list(str) { return String(str || '').split(/[\s,]+/).map(function (x) { return x.trim(); }).filter(Boolean); }

  /* true = we deliver cakes there, false = we don't. Rules live in Theme settings > Delivery rules. */
  function isHydPin(pin) {
    var pins = list(S.hydPincodes);
    var prefixes = list(S.hydPrefixes);
    if (pins.indexOf(pin) !== -1) return true;
    for (var i = 0; i < prefixes.length; i++) { if (pin.indexOf(prefixes[i]) === 0) return true; }
    return false;
  }

  function renderPinChip() {
    var pin = getPin();
    $$('[data-xo-pin-label]').forEach(function (el) {
      el.textContent = pin ? 'Deliver to ' + pin : el.getAttribute('data-empty');
    });
  }

  function setMsg(el, text, ok) {
    if (!el) return;
    el.textContent = text;
    el.classList.toggle('xo-msg-ok', ok === true);
    el.classList.toggle('xo-msg-bad', ok === false);
  }

  function initPinChip() {
    renderPinChip();
    $$('[data-xo-pin-form]').forEach(function (form) {
      var input = $('input', form);
      if (input) input.value = getPin();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var pin = cleanPin(input.value);
        if (!validPin(pin)) { input.focus(); return; }
        setPin(pin);
        var details = form.closest('details');
        if (details) details.open = false;
      });
    });
  }

  /* Home "two doors": check a Hyderabad pincode, then go to cakes. */
  function initPinCheck() {
    $$('[data-xo-pin-check]').forEach(function (form) {
      var input = $('[data-xo-pin-input]', form);
      var msg = $('[data-xo-pin-msg]', form);
      if (input && getPin()) input.value = getPin();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var pin = cleanPin(input.value);
        if (!validPin(pin)) { setMsg(msg, 'Enter a 6 digit pincode.', false); input.focus(); return; }
        setPin(pin);
        if (isHydPin(pin)) { window.location.href = form.getAttribute('data-go') || '/collections/cakes'; }
        else { setMsg(msg, 'Cakes deliver in Hyderabad only. Our chocolates ship to ' + pin + '.', false); }
      });
    });
  }

  /* Product page: shippable products ship across India; answer from the section setting. */
  function initShipCheck() {
    $$('[data-xo-ship-check]').forEach(function (form) {
      var input = $('[data-xo-pin-input]', form);
      var msg = $('[data-xo-pin-msg]', form);
      var answer = function () {
        var pin = cleanPin(input.value);
        if (!validPin(pin)) { setMsg(msg, 'Enter a 6 digit pincode.', false); return; }
        setPin(pin);
        setMsg(msg, (form.getAttribute('data-ok') || '').replace(/\{pin\}/g, pin), true);
      };
      if (getPin()) { input.value = getPin(); answer(); }
      form.addEventListener('submit', function (e) { e.preventDefault(); answer(); });
    });
  }

  /* ---------- product: options, price, image, quantity ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-xo-product-json]', root);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = $('[data-xo-product-form]', root);
    var idInput = $('[data-xo-variant-id]', root);
    var qtyInput = $('[data-xo-qty-input]', root);
    var priceEl = $('[data-xo-price]', root);
    var compareEl = $('[data-xo-compare]', root);
    var perEl = $('[data-xo-per]', root);
    var titleEl = $('[data-xo-variant-title]', root);
    var atc = $('[data-xo-atc]', root);
    var atcLabel = $('[data-xo-atc-label]', root);
    var noteEl = $('[data-xo-option-note]', root);
    var buttons = $$('[data-xo-option]', root);
    var current = product.variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || product.variants[0];
    var selected = current ? current.options.slice() : [];

    function matches(v, upTo) {
      for (var i = 0; i < upTo; i++) { if (v.options[i] !== selected[i]) return false; }
      return true;
    }

    function syncButtons() {
      var groups = {};
      buttons.forEach(function (b) {
        var oi = Number(b.getAttribute('data-xo-option'));
        (groups[oi] = groups[oi] || []).push(b);
      });
      Object.keys(groups).forEach(function (k) {
        var oi = Number(k);
        var visible = [];
        groups[k].forEach(function (b) {
          var val = b.getAttribute('data-value');
          var exists = product.variants.some(function (v) { return matches(v, oi) && v.options[oi] === val; });
          b.hidden = oi > 0 && !exists;
          if (!b.hidden) visible.push(val);
        });
        if (visible.length && visible.indexOf(selected[oi]) === -1) selected[oi] = visible[0];
        groups[k].forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-value') === selected[oi]));
        });
      });
      /* Cake weights: show the price of each weight for the chosen flavour. */
      if (groups[0]) {
        groups[0].forEach(function (b) {
          var sub = $('[data-xo-sub]', b);
          if (!sub || !root.hasAttribute('data-xo-cake')) return;
          var want = selected.slice(); want[0] = b.getAttribute('data-value');
          var v = product.variants.filter(function (x) { return x.options.join('|') === want.join('|'); })[0];
          if (v) sub.textContent = formatMoney(v.price);
        });
        var on = groups[0].filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
        if (noteEl && on) noteEl.textContent = on.getAttribute('data-sub') || '';
      }
    }

    function qty() { return Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1); }

    function render() {
      var v = product.variants.filter(function (x) { return x.options.join('|') === selected.join('|'); })[0];
      current = v || null;
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) compareEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
      if (perEl && perEl.hasAttribute('data-enabled')) {
        perEl.textContent = v.weight > 0 ? formatMoney(Math.round(v.price * 100 / v.weight)) + ' per 100 g · ' + v.weight + ' g in total' : '';
      }
      if (titleEl) titleEl.textContent = v.options.join(' · ');
      if (atc) atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? 'Add to cart · ' + formatMoney(v.price * qty()) : 'Sold out';
      if (v.featured_media) showImage(root, v.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.hidden || b.disabled) return;
        selected[Number(b.getAttribute('data-xo-option'))] = b.getAttribute('data-value');
        syncButtons();
        render();
      });
    });

    $$('[data-xo-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.min(20, Math.max(1, qty() + Number(b.getAttribute('data-xo-qty'))));
        if (qtyInput) qtyInput.value = n;
        render();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', render);

    $$('[data-xo-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { showImage(root, t.getAttribute('data-media-id')); });
    });

    if (buttons.length) { syncButtons(); render(); }

    if (root.hasAttribute('data-xo-cake') && form) initCake(root, form);
  }

  function showImage(root, mediaId) {
    var thumb = $('[data-xo-thumb][data-media-id="' + mediaId + '"]', root);
    var img = $('[data-xo-main] img', root);
    if (!thumb || !img) return;
    img.removeAttribute('srcset');
    img.src = thumb.getAttribute('data-src');
    $$('[data-xo-thumb]', root).forEach(function (t) { t.setAttribute('aria-pressed', String(t === thumb)); });
  }

  /* ---------- cake: Hyderabad pincode, delivery date, required before add ---------- */
  function istNow() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
    var get = function (t) { return Number((parts.filter(function (p) { return p.type === t; })[0] || {}).value); };
    return { y: get('year'), m: get('month'), d: get('day'), h: get('hour') };
  }

  function initCake(root, form) {
    var pinForm = $('[data-xo-cake-pin]', root);
    var pinInput = pinForm && $('[data-xo-pin-input]', pinForm);
    var pinMsg = pinForm && $('[data-xo-pin-msg]', pinForm);
    var other = pinForm && $('[data-xo-pin-other]', pinForm);
    var pinProp = $('[data-xo-prop-pin]', form);
    var dateProp = $('[data-xo-prop-date]', form);
    var formMsg = $('[data-xo-form-msg]', form);
    var datesEl = $('[data-xo-dates]', form);

    function checkPin(quiet) {
      var pin = cleanPin(pinInput.value);
      if (!validPin(pin)) { if (!quiet) setMsg(pinMsg, 'Enter a 6 digit pincode.', false); pinProp.value = ''; return false; }
      setPin(pin);
      var ok = isHydPin(pin);
      var text = (pinForm.getAttribute(ok ? 'data-ok' : 'data-bad') || '').replace(/\{pin\}/g, pin);
      setMsg(pinMsg, text, ok);
      if (other) other.hidden = false;
      pinProp.value = ok ? pin : '';
      return ok;
    }

    if (pinForm) {
      pinForm.addEventListener('submit', function (e) { e.preventDefault(); checkPin(false); });
      if (getPin()) { pinInput.value = getPin(); checkPin(true); }
    }

    /* Dates: today if before the cut-off hour (IST), else from tomorrow. */
    if (datesEl) {
      var now = istNow();
      var start = new Date(Date.UTC(now.y, now.m - 1, now.d));
      var firstOffset = now.h >= (S.cutoffHour || 18) ? 1 : 0;
      var days = S.cakeDays || 4;
      var dayFmt = new Intl.DateTimeFormat('en-GB', { weekday: 'short', timeZone: 'UTC' });
      var dateFmt = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' });
      var fullFmt = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
      datesEl.style.gridTemplateColumns = 'repeat(' + Math.min(days, 4) + ', minmax(0, 1fr))';
      for (var i = 0; i < days; i++) {
        var off = firstOffset + i;
        var d = new Date(start.getTime() + off * 86400000);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'xo-box xo-box--cake';
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('data-date', fullFmt.format(d));
        b.innerHTML = '<small>' + (off === 0 ? 'Today' : off === 1 ? 'Tomorrow' : dayFmt.format(d)) + '</small><b>' + dateFmt.format(d) + '</b>';
        b.addEventListener('click', function (ev) {
          var btn = ev.currentTarget;
          $$('button', datesEl).forEach(function (x) { x.setAttribute('aria-pressed', String(x === btn)); });
          dateProp.value = btn.getAttribute('data-date');
        });
        datesEl.appendChild(b);
      }
      var first = $('button', datesEl);
      if (first) first.click();
    }

    form.addEventListener('submit', function (e) {
      if (pinInput && !pinProp.value && !checkPin(false)) {
        e.preventDefault();
        setMsg(formMsg, 'Check a Hyderabad pincode first. Cakes deliver in Hyderabad only.', false);
        pinInput.focus();
        return;
      }
      if (dateProp && !dateProp.value) {
        e.preventDefault();
        setMsg(formMsg, 'Pick a delivery date.', false);
        return;
      }
      /* Leave empty properties (e.g. no topper message) out of the order. */
      $$('[name^="properties["]', form).forEach(function (el) { if (!el.value.trim() && el.type !== 'radio') el.disabled = true; });
    });
  }

  /* ---------- accordions, help tabs ---------- */
  function initAccordions() {
    $$('[data-xo-accordion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', String(open));
        if (body) body.hidden = !open;
        var sign = $('[data-xo-sign]', btn);
        if (sign) sign.textContent = open ? '−' : '+';
      });
    });
  }

  function initHelp() {
    $$('[data-xo-help]').forEach(function (root) {
      var tabs = $$('[data-xo-topic]', root);
      var panels = $$('[data-xo-topic-panel]', root);
      function show(i) {
        tabs.forEach(function (t) { t.setAttribute('aria-current', String(t.getAttribute('data-xo-topic') === String(i))); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-xo-topic-panel') !== String(i); });
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-xo-topic')); }); });
      var hash = window.location.hash.replace('#', '');
      var start = 0;
      panels.forEach(function (p) { if (hash && p.id === hash) start = p.getAttribute('data-xo-topic-panel'); });
      show(start);
    });
  }

  /* ---------- collection "Show more", recommendations ---------- */
  function initShowMore() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-xo-more]');
      if (!a) return;
      e.preventDefault();
      a.setAttribute('aria-busy', 'true');
      fetch(a.href, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = $('[data-xo-grid]');
          var next = $('[data-xo-grid]', doc);
          if (grid && next) { while (next.firstElementChild) grid.appendChild(next.firstElementChild); }
          var wrap = a.closest('[data-xo-more-wrap]');
          var nextWrap = $('[data-xo-more-wrap]', doc);
          if (wrap) { if (nextWrap) wrap.replaceWith(nextWrap); else wrap.remove(); }
        })
        .catch(function () { window.location.href = a.href; });
    });
  }

  function initRecommendations() {
    $$('[data-xo-recs]').forEach(function (el) {
      fetch(el.getAttribute('data-url'), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-xo-recs]', doc);
          if (fresh && fresh.children.length) { el.innerHTML = fresh.innerHTML; }
          else { var section = el.closest('[data-section]'); if (section) section.hidden = true; }
        })
        .catch(function () { /* leave the rail empty */ });
    });
  }

  /* ---------- cart: express shipping product toggle ---------- */
  function initExpress() {
    $$('[data-xo-express]').forEach(function (box) {
      box.addEventListener('change', function () {
        var req = box.checked
          ? fetch(S.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(box.getAttribute('data-variant')), quantity: 1 }) })
          : fetch(S.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(box.getAttribute('data-line')), quantity: 0 }) });
        req.then(function () { window.location.reload(); });
      });
    });
  }

  /* ---------- phone menu ---------- */
  function initDrawer() {
    var drawer = $('[data-xo-drawer]');
    var openBtn = $('[data-xo-drawer-open]');
    if (!drawer || !openBtn) return;
    function set(open) {
      drawer.hidden = !open;
      openBtn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) { var close = $('[data-xo-drawer-close]', drawer); if (close) close.focus(); } else { openBtn.focus(); }
    }
    openBtn.addEventListener('click', function () { set(true); });
    $$('[data-xo-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) set(false); });
  }

  function init() {
    initDrawer();
    initPinChip();
    initPinCheck();
    initShipCheck();
    $$('[data-xo-product-root]').forEach(initProduct);
    initAccordions();
    initHelp();
    initShowMore();
    initRecommendations();
    initExpress();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
